module.exports = __webpack_public_path__ + "static/media/Section 2  - Person.be1ab904.svg";